import { ReactNode, forwardRef } from 'react';

import * as Styled from './activity-builder-page-preview-shared.style';

export const PagePreviewContent = forwardRef(
  (
    {
      children,
      header,
      footer,
      dimensions,
      isLoading,
      bgUrl,
    }: {
      children: ReactNode;
      header?: ReactNode;
      footer?: ReactNode;
      dimensions: {
        pageHeight: number;
        contentHeight: number;
      };
      isLoading?: boolean;
      bgUrl?: string;
    },
    ref
  ) => (
    <Styled.PagePreviewWrapper
      ref={ref as any}
      $isLoading={isLoading}
      $height={dimensions.pageHeight}
    >
      <Styled.PagePreview
        $bgUrl={bgUrl || null}
        $height={dimensions.pageHeight}
      >
        <Styled.PagePreviewSlide>
          {header}
          <Styled.PagePreviewSlideContent $height={dimensions.contentHeight}>
            {children}
          </Styled.PagePreviewSlideContent>
          {footer}
        </Styled.PagePreviewSlide>
      </Styled.PagePreview>
    </Styled.PagePreviewWrapper>
  )
);
